const ytVideoData = [
  {
    youtubeLink: "tk1lYjNkF34",
    practiceLink: "https://njent.com/samir-undavia/",
    drName:
      "Samir Undavia, MD, Facial Plastic Surgeon & Rhinoplasty Specialist, Guest contributor",
  },
];

export default ytVideoData;
